import ApiService from './ApiService';

export default {
  /**
   * Finds account by ID
   * @param {number} id Account ID
   * @returns {Promise<any>}
   */
  findById(id) {
    return new Promise((resolve, reject) => {
      const data = {
        id,
        includes: 'users',
      };
      ApiService.request('GET', 'accounts', data).then((response) => {
        if (response.status === 200 && response.data.length === 1) {
          resolve(response.data[0]);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Creates a new account
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  create(data) {
    return new Promise((resolve, reject) => {
      ApiService.request('POST', 'accounts', data).then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  /**
   * Updates an account
   * @param {number} id Account ID
   * @param {array} data Data
   * @returns {Promise<any>}
   */
  update(id, data) {
    return new Promise((resolve, reject) => {
      ApiService.request('PUT', `accounts/${id}`, data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
